/// <amd-module name="Analytics/Shared/Analytics-Visuals-Common/LoadingComponent/LoadingComponent" />
import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { ISpinnerProps, Spinner } from "VSSUI/Spinner";

export class LoadingComponent extends VssComponent<ISpinnerProps, {}> {
    public render(): JSX.Element {
        return <Spinner {...this.props} />;
    }
}
